export const COMPANION_ROUTES = {
  ADD_ASSISTANT: '/add-assistant',
  ADD_ASSISTANT_URL: '/add-assistant-url',
  IN_MEETING: '/bot/:botId',
} as const;

export const APP_ROUTES = {
  HOME: '/',
  WEB: '/web',
  ZOOM: '/zoom',
  WEBEX: '/webex',
  TEAMS: '/teams',
  TEAMS_AUTH: '/teams-auth',
  EXTERNAL_AUTH: '/external-auth',
  EXTERNAL_AUTH_COMPLETE: '/external-auth/complete',
  MEET: '/meet',
  ERROR: '/error',
  SERVICE_UNAVAILABLE: '/503',
  SERVER_ERROR: '/500',
  NOT_FOUND: '*',
  TERMS: '/terms',
  CA_TERMS: '/ca-terms',
  SUPPORT_TERMS: '/support-terms',
  CONSENT: '/consent',
};
